import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss']
,  standalone: false
})
export class SignatureComponent implements OnInit {
  @Input() labelText: string = "";
  @Input() isRequired: boolean = false;
  @Output() value: EventEmitter<string> = new EventEmitter();
id: any;

  ngOnInit() {
    //This blank function is mandatory.
  }

  textOnChange(event: string) {
        
    this.value.emit(event);
}
}
